<script>
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: ['values', 'barWidth'],
  watch: {
    values: {
      handler () {
        this.chartData.labels = this.values.labels,
        this.chartData.datasets = [
          {
            label: 'Compra',
            data: this.values.long,
            backgroundColor: '#7BA6E8',
            borderWidth: 0,
            barPercentage: this.barWidth,
            categoryPercentage: 1
          },
          {
            label: 'Venda',
            data: this.values.short,
            backgroundColor: '#7BE8B4',
            borderWidth: 0,
            barPercentage: this.barWidth,
            categoryPercentage: 1
          }
        ]
        this.$data._chart.update()
      },
      deep: true
    }
  },
  data () {
    return {
      chartData: {
        labels: [],
        datasets: []
      },
      options: {
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              stacked: true,
              gridLines: {
                color: '#e2e2e2',
                drawOnChartArea: false
              }
            }
          ],
          yAxes: [
            {
              stacked: true,
              gridLines: {
                color: '#e2e2e2',
                drawOnChartArea: true
              }
            }
          ]
        }
      }
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>
